import axios from "axios";
export default {

    state: {},
    mutations: {},
    getters: {},
    actions: {
        // Fetch player information
        async fetchPlayerData({ getters }, payload) {
            const filterOptions = setFilterOptionsOperatorAndNetworkId(payload.filterOptions, getters);
            try {
                const response = await axios.post(`/api/${payload.report}/${payload.dataset}`, filterOptions);
                return response;
            } catch (error) {
                if (error.response.status === 419) {
                    this.dispatch("logout");
                } else {
                    console.log(error);
                }
            }
        },
    }

}

function setFilterOptionsOperatorAndNetworkId(filterOptions, getters) {
    // If user has an operator ID, always use that as this means user should only ever see data for that operator.
    if (getters.getUserOperatorId || !('operatorId' in filterOptions && filterOptions.operatorId)) {
        filterOptions.operatorId = getters.getUserOperatorId;
    }

    // If user has an network ID, always use that as this means user should only ever see data for that network.
    if (getters.getUserNetworkId || !('networkId' in filterOptions && filterOptions.networkId)) {
        filterOptions.networkId = getters.getUserNetworkId;
    }

    // Set the user User Id.
    if (getters.getUserId) {
        filterOptions.userId = getters.getUserId;
    }

    // Finally, add JWT token for validation in API.
    filterOptions.token = getters.getCognitoJwtToken;

    return filterOptions;
}